import { Routes } from '@angular/router';
import { ServiceBusMetricsComponent } from './service-bus-metrics/service-bus-metrics.component';
import { BuildHealthComponent } from './build-health/build-health.component';
import { OldFeatureFlagChartComponent } from 'src/app/old-feature-flag-chart/old-feature-flag-chart.component';
import { DashboardComponent } from './dashboard/dashboard.component';
import { NotFoundComponent } from 'src/app/not-found/not-found.component';
import { AdalRoleGuard } from 'src/app/adal.role.guard';
import { AgentCapabilitiesComponent } from './agent-capabilities/agent-capabilities.component';
var ɵ0 = {
    title: 'Dashboard',
    roles: ['Observer', 'Writer', 'Admin'],
    icon: 'dashboard',
    autoReload: { min: 5, max: 10 }
}, ɵ1 = {
    title: 'Build Health',
    roles: ['Observer', 'Writer', 'Admin'],
    icon: 'build',
    autoReload: { min: 5, max: 10 }
}, ɵ2 = {
    title: 'Service Bus Metrics',
    roles: ['Observer', 'Writer', 'Admin'],
    icon: 'notifications'
}, ɵ3 = {
    title: 'Old Feature Flags',
    roles: ['Admin'],
    icon: 'flag'
}, ɵ4 = {
    title: 'Agent Capabilities',
    roles: ['Admin'],
    icon: 'whatshot'
};
var routes = [
    // default
    {
        path: '', redirectTo: 'dashboard', pathMatch: 'full'
    },
    {
        path: 'dashboard', component: DashboardComponent, canActivate: [AdalRoleGuard],
        data: ɵ0
    },
    {
        path: 'buildHealth', component: BuildHealthComponent, canActivate: [AdalRoleGuard],
        data: ɵ1
    },
    {
        path: 'serviceBusMetrics', component: ServiceBusMetricsComponent, canActivate: [AdalRoleGuard],
        data: ɵ2
    },
    {
        path: 'oldFeatureFlagChart', component: OldFeatureFlagChartComponent, canActivate: [AdalRoleGuard],
        data: ɵ3
    },
    {
        path: 'agentCapabilities', component: AgentCapabilitiesComponent, canActivate: [AdalRoleGuard],
        data: ɵ4
    },
    // not found
    { path: '**', component: NotFoundComponent }
];
var AppRoutingModule = /** @class */ (function () {
    function AppRoutingModule() {
    }
    return AppRoutingModule;
}());
export { AppRoutingModule };
export { ɵ0, ɵ1, ɵ2, ɵ3, ɵ4 };
